import React from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function RichTextEditor({ htmlContent, setHTMLContent, style, placeholder }) {
    const Parchment = Quill.import('parchment');

    return (
        <ReactQuill
            theme="snow"
            value={htmlContent}
            onChange={(content) => setHTMLContent(content)}
            style={style}
            placeholder={placeholder}
            formats={
                [
                    "background", "bold", "color", "font", "code", "italic", "link", "size", "strike", "script", "underline",
                    "blockquote", "header", "indent", "list", "align", "direction", "code-block", 
                    "image", "video",
                ]
            }
        />
    );
}

export default RichTextEditor;